.root {
  display: inline-block;
  margin-right: 1rem;
  position: relative;
}

.trigger {
  background: transparent;
  border: 0;
  color: var(--color-text-on-primary);
  cursor: pointer;
  display: inline-block;
  font: inherit;
  padding-bottom: 0.25rem;
  text-decoration: none;
}

.trigger:hover {
  text-decoration: underline;
}

.trigger:focus-visible {
  outline: 2px solid var(--color-background);
  outline-offset: 2px;
  text-decoration: underline;
}

.menu {
  background: var(--color-background);
  border: 1px solid var(--color-muted);
  border-radius: 16px;
  box-shadow: 7px 10px 14px 3px rgba(0, 0, 0, 0.26);
  display: flex;
  flex-direction: column;
  font-family: var(--font-family-base);
  left: -50%;
  line-height: 2.5;
  margin-top: 0rem;
  padding: 1rem;
  position: absolute;
  top: 100%;
  width: 340px;
  z-index: 200;
}

.menu[hidden] {
  display: none;
}
